export default __webpack_public_path__ + "static/media/available_version_img.6941dbb7.png";